import Vue from 'vue';
import Vuex from 'vuex';
import app from '@/vuex/app';
import auth from '@/vuex/auth';
import tenants from '@/vuex/tenants';
import alerts from '@/vuex/alerts';
import dashboard from '@/vuex/dashboard';

const debug = process.env.NODE_ENV !== 'production';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    app,
    auth,
    tenants,
    alerts,
    dashboard
  },
  strict: debug
});
